module.exports = __webpack_public_path__ + "static/media/header-sponsors-mobile.ae8261d1.png";